import { createHash } from 'crypto'

export function sha256(input: any) {
  const text = typeof input === 'string' ? input : JSON.stringify(input)
  return createHash('SHA256').update(text).digest('hex')
}
